import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueI18n)
Vue.use(VueLocalStorage)

function loadLocaleMessages() {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export function getLanguage() {
  return Vue.localStorage.get('lang', navigator.language || navigator.userLanguage) || 'zh';
}

export default new VueI18n({
  silentTranslationWarn: true,
  locale: getLanguage(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
